export default __webpack_public_path__ + "static/media/animalfriend.cfeb69db.png";